const reception = [
  {
    path: '/approval/box/reception/vacation',
    component: () => import('@/page/approval/box/reception/VacationReceptionList.vue'),
    meta: {
      name: '휴가 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/mealcost',
    component: () => import('@/page/approval/box/reception/MealCostReceptionList.vue'),
    children: [
      {
        path: '/approval/box/reception/mealcost/detail/:id',
        component: () => import('@/page/approval/box/reception/MealCostReceptionDetail.vue'),
        meta: {
          name: '식대비 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '식대비 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/expense',
    component: () => import('@/page/approval/box/reception/ExpenseReceptionList.vue'),
    children: [
      {
        path: '/approval/box/reception/expense/detail/:id',
        component: () => import('@/page/approval/box/reception/ExpenseReceptionDetail.vue'),
        meta: {
          name: '지출결의서 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '지출결의서 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/submit',
    component: () => import('@/page/approval/box/reception/SubmitReceptionList.vue'),
    children: [
      {
        path: '/approval/box/reception/submit/detail/:id',
        component: () => import('@/page/approval/box/reception/SubmitReceptionDetail.vue'),
        meta: {
          name: '품의서 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '품의서 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/holidaywork',
    component: () => import('@/page/approval/box/reception/HolidayWorkReceptionList.vue'),
    children: [
      {
        path: '/approval/box/reception/holidaywork/detail/:id',
        component: () => import('@/page/approval/box/reception/HolidayWorkReceptionDetail.vue'),
        meta: {
          name: '휴일근무 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '휴일근무 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/admit',
    component: () => import('@/page/approval/box/reception/AdmitReceptionList.vue'),
    children: [
      // {
      //     path: '/approval/box/reception/admit/all',
      //     component: () => import ('@/page/approval/box/reception/AdmitReceptionAll'),
      //     meta: {
      //         name: '인정휴가 지급 일괄 결재 목록',
      //         isMenu: false
      //     }
      // },
      {
        path: '/approval/box/reception/admit/detail/:id',
        component: () => import('@/page/approval/box/reception/AdmitReceptionDetail.vue'),
        meta: {
          name: '인정휴가 지급 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '인정휴가 지급 수신함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reception/businesstrip',
    component: () => import('@/page/approval/box/reception/BusinessTripReceptionList.vue'),
    children: [
      {
        path: '/approval/box/reception/businesstrip/detail/:id',
        component: () => import('@/page/approval/box/reception/BusinessTripReceptionDetail.vue'),
        meta: {
          name: '출장결과보고서 수신 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '출장결과보고서 수신함',
      isMenu: false,
    },
  },
];

export default reception;
